import { render } from "./SasAdmission.vue?vue&type=template&id=6ea3fe1e"
import script from "./SasAdmission.vue?vue&type=script&lang=js"
export * from "./SasAdmission.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__